export default __webpack_public_path__ + "static/media/error.213ce927.wav";